import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "wk-access-denied",
    standalone: false,
    templateUrl: "./access-denied.component.html",
    styleUrl: "./access-denied.component.scss",
})
export class AccessDeniedComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private translateService = inject(TranslateService);

    constructor() {}

    ngOnInit(): void {
        const lang = this.route.snapshot.params["lang"];
        if (lang) {
            this.translateService.use(lang);
        }
    }
}
